import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const originalTitle: TComputedPropMapper<string | null> = props => {
  return props.offer.title;
};
